// extracted by mini-css-extract-plugin
export var subtitle = "_cy-2";
export var title = "_cy-0";
export var titleNoWrap = "_cy-1";